<template>
  <v-date-picker
    v-model="current"
    :events="events"
    locale="ja-jp"
    no-title
    :full-width="true"
    :day-format="date => new Date(date).getDate()"
  ></v-date-picker>
</template>

<script>
export default {
  props: {
    value: {},
    datetimes: {}
  },
  computed: {
    current: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    events(date) {
      return this.datetimes.hasOwnProperty(date) && this.datetimes[date].length
        ? true
        : false;
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ {
  .v-date-picker-table.v-date-picker-table--date
    > table
    > tbody
    tr
    td:nth-child(7)
    .v-btn__content {
    color: blue;
  }
  .v-date-picker-table.v-date-picker-table--date
    > table
    > tbody
    tr
    td:nth-child(1)
    .v-btn__content {
    color: red;
  }
}
</style>
